import { trigger, transition, style, animate } from '@angular/animations';
import {
    Component, Input
  } from '@angular/core';
import { Subscription } from 'rxjs';
import { InformationBar } from './information-bar.model';
import { InformationBarService } from './information-bar.service';
import { InformationBarType } from './information-bar.type';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
  
@Component({
    selector: 'information-bar',
    templateUrl: 'information-bar.component.html',
    styleUrls: ['information-bar.style.scss'],
    standalone: true,
    imports: [CommonModule, MatIconModule],
    animations: [
        trigger('fade', [
          transition('void => active', [ // using status here for transition
            style({ opacity: 0, transform: 'translateY(-10px)' }),
            animate('400ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
          ]),
          transition('* => void', [
            animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
          ])
        ])
    ]
})
export class InformationBarComponent {
  private _id = 'default-information-bar';
  @Input() 
  set id(value: string) {
    if (this._id !== value) {
      this._id = value;
      // Re-subscribe to the service with the new ID
      if (this.informationBarSubscription) {
        this.informationBarSubscription.unsubscribe();
      }
      this.subscribeToService();
    }
  }
  get id(): string {
    return this._id;
  }
  
  message: String;
  informationBars: InformationBar[] = [];
  informationBarSubscription: Subscription;
  @Input() fade = true;
  status: boolean;

  constructor(private informationBarService: InformationBarService) {
    this.status = false;
  }

    ngOnInit() {
        this.subscribeToService();
    }

    private subscribeToService() {
        // subscribe to new informationBar notifications
        this.informationBarSubscription = this.informationBarService.onInformationBar(this._id)
            .subscribe(informationBar => {
                if (informationBar.remove && informationBar.remove === true) {
                    let informationBarTmp = this.informationBars.find(x => {
                        if (x && typeof x.idInformationBar !== 'undefined' && x.idInformationBar) {
                            return x.idInformationBar == informationBar.idInformationBar
                        }
                    });
                    this.removeInformationBar(informationBarTmp);
                } else {
                    // add informationBar to array
                    this.informationBars.push(informationBar);

                    // auto close informationBar if required
                    if (informationBar.autoClose) {
                        setTimeout(() => {
                            this.status = true;
                            this.removeInformationBar(informationBar);
                            this.status = false;
                        }, 5000); // Increased from 3000ms for better UX
                    }
                }
        });
    }

    ngOnDestroy() {
        // unsubscribe to avoid memory leaks
        this.informationBarSubscription.unsubscribe();
    }

    removeInformationBar(informationBar: InformationBar) {
        // check if already removed to prevent error on auto close
        if (!this.informationBars.includes(informationBar)) return;

        if (this.fade) {
            // fade out informationBar
            this.informationBars.find(x => x === informationBar).fade = true;

            // remove informationBar after faded out with smoother timing
            this.status = true;
            setTimeout(() => {
                this.informationBars = this.informationBars.filter(x => x !== informationBar);
                this.status = false;
            }, 300); // Increased from 250ms for smoother transition
        } else {
            // remove informationBar
            this.informationBars = this.informationBars.filter(x => x !== informationBar);
        }
    }

    cssClass(informationBar: InformationBar) {
        if (!informationBar) return;

        const classes = [];
                
        const informationBarTypeClass = {
            [InformationBarType.Success]: 'bg-green-300',
            [InformationBarType.Error]: 'bg-red-300',
            [InformationBarType.Info]: 'bg-blue-300',
            [InformationBarType.Warning]: 'bg-yellow-300'
        }

        classes.push(informationBarTypeClass[informationBar.type]);

        return classes.join(' ');
    }

}